import { render, staticRenderFns } from "./TheDepositInfoDialog.vue?vue&type=template&id=715d6719&scoped=true"
import script from "./TheDepositInfoDialog.vue?vue&type=script&lang=js"
export * from "./TheDepositInfoDialog.vue?vue&type=script&lang=js"
import style0 from "./TheDepositInfoDialog.vue?vue&type=style&index=0&id=715d6719&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715d6719",
  null
  
)

export default component.exports